import { render, staticRenderFns } from "./RouterOurNodes.vue?vue&type=template&id=68ef2928&"
import script from "./RouterOurNodes.vue?vue&type=script&lang=js&"
export * from "./RouterOurNodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports